import { Box, Tooltip, Typography } from "@mui/material"
import { uniqueId } from "library/database/split-id.mjs"
import Iconify from "minimals-template/components/Iconify"
import { statusIcons } from "routes/facilities/lib/status-icons"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSchedule } from "routes/schedule/lib/useSchedule"
import { ScheduleCodeDisplay } from "slot-definitions"
import { getTailoredScheduleCode } from "routes/regime/schedule-code-presenter"
import { toDataCy } from "lib/to-data-cy"

export function ScheduleCode({ sx, code, dataCy }) {
    const { payload, schedule } = useBoundContext()
    const { schedule: modified } = useSchedule(schedule?.id) ?? {}
    const displayCode = getTailoredScheduleCode(code ?? modified?.code, payload)

    if ((Object.isEmpty(modified) || !modified) && !displayCode) return null
    return (
        <ScheduleCodeDisplay.Slot sx={sx} schedule={modified} code={displayCode}>
            <Typography data-cy={dataCy} variant="caption" component="div" sx={{ ml: 2, whiteSpace: "nowrap", ...sx }}>
                #{displayCode}
            </Typography>
        </ScheduleCodeDisplay.Slot>
    )
}

export function ScheduleStatus() {
    const { parentItem, schedule } = useBoundContext()
    let status = parentItem.data?.statuses?.[uniqueId(schedule._id)]
    if (typeof status === "string") {
        status = parentItem.data.statuses[uniqueId(schedule._id)] = { summary: status, reasons: [] }
    }
    return <ScheduleStatusTooltipIcon reasons={status?.reasons} summary={status?.summary} />
}

export function ScheduleStatusTooltipIcon({ reasons = [], summary }) {
    return (
        <Tooltip arrow title={reasons.join(", ")}>
            <Box data-cy={toDataCy("schedule-status", summary)} width={16} sx={{ color: summary }}>
                <Iconify icon={statusIcons[summary]} />
            </Box>
        </Tooltip>
    )
}
